import { downloadFile } from "../services/apiHelpers";
import { ServerFile } from "../types/components";

export const bytesToKilobytes = (bytes: number) => {
  return Math.floor(bytes / 1024);
};

export const formatAllowedTypesForAccept = (allowedTypes: string): string => {
  return allowedTypes
    .split(",")
    .map((type) => `${type.trim().toLowerCase()}`)
    .join(",");
};

export const isAllowedType = (file: File, allowedTypes: string) => {
  const validExtensions = allowedTypes?.split(",").map((type) => `${type.trim().toLowerCase()}`);
  const fileExtension = file.name.split(".").pop()?.toLowerCase();

  return validExtensions.includes(`.${fileExtension}`);
};

export const download = async (file?: ServerFile) => {
  if (!file) {
    return;
  }

  const blob = await downloadFile(file.id);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.download = file.file_name;
  link.href = url;

  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
